/**
 * 活动配置信息
 */
Object.assign(UpAct.CONFIG, {
    // 活动ID｛String | Array｝。若不设置。默认获取的是URL参数acid=xxx
    acid: '',
    // 开启MOCK模式，使用mock数据，否则使用真是接口数据。
    mockMode: 1,
    // 礼物个数；n个礼物榜单
    giftNum: 3,
    // 离线送礼物，赠送份数
    quantityGroup: [1, 10, 100, 1000, 10000],
    // 离线送礼物，默认赠送份数
    defaultQuantity: 1
});


// WEBPACK FOOTER //
// ./js/config.js